import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetTaxDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Tax/GetDetail?` + params, null);

export const GetTaxList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Tax/GetList?` + params, null);

export const CreateTax = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Tax/Create`, data);

export const UpdateTax = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Tax/Update`, data);    

export const DeleteTax = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Tax/Delete`, data);
